import { MAP_MISTAKES_ENABLE, CHANGE_FORM_STATE, START_SENDING } from './actions';
import { REPORT_MISTAKES, checkForMenuTypes } from '../mapbuttons/menuTypes';
import { ENABLE_MENU } from '../mapbuttons/actions';
import { PERSON_SEARCH_ENABLE } from '../personSearch/actions';

const DefaultState = {
  enabled: false,
  formState: 'default',
  data: [] //geojson data
};

const mapMistakes = (state = DefaultState, action) => {
  switch (action.type) {    
    case PERSON_SEARCH_ENABLE:
      if (action.data && state.enabled && window.innerWidth <= 1000) {
        state.enabled = false;
      }

      return Object.assign({}, state);

    case MAP_MISTAKES_ENABLE:
    case ENABLE_MENU:

      if(typeof action.menuType !== 'undefined' && action.menuType !== REPORT_MISTAKES) {

        if(action.enableState) {
          state.enabled = false;
          return Object.assign({}, state);
        }

        return state;
      }

      if(state.enabled) {
        state.enabled = false;
      } else {
        state.enabled = true;
        state.formState = 'default';
      }

      if(action.enableState) {
        state.enabled = action.enableState;
      }

      
      return Object.assign({}, state);
    case CHANGE_FORM_STATE:

      state.formState = action.state;
      if (state.formState == "finished" || state.formState == "default") {
        state.startSending = false;
      }
      
      return Object.assign({}, state);
    case START_SENDING:
      state.startSending = true;

      return Object.assign({}, state);
    default:
      return state;
  }
};

export {mapMistakes};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mapMistakes/reducer.js